import React, { useState, useEffect } from "react";
import { Image as AmImage } from "antd-mobile";
import classNames from "@/utils/classNames";
import type { TSkus, TSkuProp } from "@/typings";
import "./index.scss";

const classPrefix = "yfm-product-detail-sku";

interface ProductSkuProps {
  cover?: string | null;
  price?: string | null;
  originalPrice?: string | null;
  skuProps: TSkuProp[];
  skus?: TSkus | null;
}

const ProductSku: React.FC<ProductSkuProps> = ({
  cover,
  price,
  originalPrice,
  skuProps,
  skus,
}) => {
  const [selectedSku, setSelectedSku] = useState<{
    cover: string;
    price: string;
    originPrice: string;
    propsValueIds: string[];
    skuInfos: string[];
  }>({
    cover: "",
    price: "",
    originPrice: "",
    propsValueIds: [],
    skuInfos: [],
  });

  useEffect(() => {
    setSelectedSku({
      cover: cover ?? "",
      price: price ?? "",
      originPrice: originalPrice ?? "",
      propsValueIds: [],
      skuInfos: [],
    });
  }, [cover, price, originalPrice]);

  const switchProps = (
    propItemIndex: number,
    propsIndex: number,
    propValueId: string
  ) => {
    const newPropsValueIds = [...selectedSku.propsValueIds];
    const newSkuInfos = [...selectedSku.skuInfos];

    if (newPropsValueIds[propItemIndex] === propValueId) {
      newPropsValueIds[propItemIndex] = "";
      newSkuInfos[propItemIndex] = "";
    } else {
      newPropsValueIds[propItemIndex] = propValueId;
      newSkuInfos[propItemIndex] =
        skuProps[propItemIndex]?.items?.[propsIndex]?.prop_value ?? "";
    }

    let newCover = selectedSku.cover;
    if (propItemIndex === 0 && skuProps[0]?.items[propsIndex]?.has_img === 1) {
      newCover = skuProps[0].items[propsIndex]?.image ?? "";
    }

    const skuKey = "sku_" + newPropsValueIds.join("_");
    const newPrice = selectedSku.price;
    const newOriginPrice = selectedSku.originPrice;
    const newSkuPrice = skus?.[skuKey]?.real_price_value_str;
    const newSkuOriginPrice = skus?.[skuKey]?.original_price_str;

    setSelectedSku({
      cover: newCover,
      price: newSkuPrice || newPrice,
      originPrice: newSkuOriginPrice || newOriginPrice,
      propsValueIds: newPropsValueIds,
      skuInfos: newSkuInfos,
    });
  };

  return (
    <div className={classPrefix}>
      <div className={`${classPrefix}__top`}>
        <div className={`${classPrefix}__product-cover`}>
          <AmImage
            lazy
            width="100%"
            height="100%"
            src={selectedSku.cover}
            alt=""
          />
        </div>
        <div className={`${classPrefix}__product-info`}>
          <div className={`${classPrefix}__product-info-price`}>
            <span className={`${classPrefix}__price`}>{selectedSku.price}</span>
            {selectedSku.originPrice !== selectedSku.price && (
              <span className={`${classPrefix}__original-price`}>
                {selectedSku.originPrice}
              </span>
            )}
          </div>
          <div className={`${classPrefix}__product-info-sku-info`}>
            {selectedSku.skuInfos.filter((item) => item.length > 0).join(", ")}
          </div>
        </div>
      </div>
      {/* <div style={{ maxHeight: 220, overflow: "auto" }}>
        <pre>{JSON.stringify(selectedSku, null, 2)}</pre>
      </div> */}
      <div className={`${classPrefix}__props`}>
        {skuProps.map((item, itemIndex) => (
          <div className={`${classPrefix}__props-item`} key={itemIndex}>
            <p className={`${classPrefix}__title`}>{item.prop_name}</p>
            <ul className={`${classPrefix}__props-item-values`}>
              {item.items.map((propItem, index) => (
                <li
                  key={index}
                  onClick={() =>
                    switchProps(itemIndex, index, propItem.prop_value_id)
                  }
                  className={classNames(`${classPrefix}__props-item-value`, {
                    [`${classPrefix}__props-item-value--text`]:
                      propItem.has_img === 0,
                    [`${classPrefix}__props-item-value--image`]:
                      propItem.has_img === 1,
                    active: selectedSku.propsValueIds.includes(
                      propItem.prop_value_id
                    ),
                  })}
                >
                  {propItem.has_img === 1 ? (
                    <AmImage
                      src={propItem?.image}
                      width="100%"
                      height="100%"
                      alt=""
                    />
                  ) : (
                    <span>{propItem.prop_value}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductSku;
